<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { UITabPane, UITabs } from "@gohighlevel/ghl-ui";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import SidebarCustomFields from "./SidebarCustomFields.vue";
import SidebarStandardFields from "./SidebarStandardFields.vue";

const { t } = useI18n();

const store = useAppStore();

// Use computed properties for reactive translations
const quickAdd = computed(() => t("common.quickAdd"));
const customFields = computed(() => t("common.addObjectFields"));
</script>
<template>
  <UITabs justify-content="center" default-value="standard" type="segment">
    <UITabPane name="standard" :tab="quickAdd">
      <SidebarStandardFields />
    </UITabPane>
    <UITabPane name="custom" :tab="customFields">
      <SidebarCustomFields :custom-fields="store.getCustomFieldsFromStore" />
    </UITabPane>
  </UITabs>
</template>
